module.exports = __webpack_public_path__ + "static/media/whatWeDo.3f3f734f.mp4";